<template>
    <div class="form_group form_group_shareholder">
        <display-message :option="message_option"></display-message>
        <div class="form_row">
            <label :for="'shareholder_'+current_shareholder_id+'_shareholder'" v-html="cache_data_label.shareholder_id" v-show="cache_data.shareholder_id"></label>
            <div class="select_container" v-show="!current_contact_id">
                <select :id="'shareholder_'+current_shareholder_id+'_shareholder'" v-model="cache_data.shareholder_id" :placeholder="cache_data_label.shareholder_id" @change="current_contact_id = (cache_data.shareholder_id=='Add New'?'new':'');set_beneficial_owner_id()">
                    <option value="" disabled>-- {{ cache_data_label.shareholder_id }} --</option>
                    <option :value="contact.id" v-for="contact in item_list.contacts">{{ contact.formatted_name }}</option>
                    <option value="Add New">Add New</option>
                </select>
            </div>
            <p style="display:block;margin:0;padding: 0.5em 0 0.5em 1em;font-size: 0.8em;" v-show="!current_contact_id && cache_data.shareholder_id"><a style="font-size: 1.25em;text-decoration: underline;" href="javascript:void(0)" @click="current_contact_id = cache_data.shareholder_id">Click here to edit shareholder details</a> Note: Editing details will change them anywhere else these details are used</p>
        </div>
        <update-contact v-show="current_contact_id" :current_contact_id="current_contact_id" @submit="change_shareholder" :option="{item_list:item_list,item_map:item_map,contact_id:'shareholder_'+current_shareholder_id,contact_for:'shareholder'}"></update-contact>

        <div class="form_row form_row_checkbox_container" v-show="cache_data.shareholder_id && cache_data.shareholder_id !== 'Add New'">
            <label style="font-size: 1.5em;font-weight: normal;" for="beneficial_owner_is_shareholder">Is beneficial owner</label>
            <input id="beneficial_owner_is_shareholder" type="checkbox" v-model="flag_beneficial_owner_is_shareholder" @change="set_beneficial_owner_id()">
        </div>
        <div class="form_row" v-show="!flag_beneficial_owner_is_shareholder">
            <label :for="'shareholder_'+current_shareholder_id+'_beneficial_owner'" v-html="cache_data_label.beneficial_owner_id" v-show="cache_data.beneficial_owner_id !== ''"></label>
            <div class="select_container" v-show="!current_beneficial_owner_id">
                <select :id="'shareholder_'+current_shareholder_id+'_beneficial_owner'" v-model="cache_data.beneficial_owner_id" :placeholder="cache_data_label.beneficial_owner_id" @change="current_beneficial_owner_id = (cache_data.beneficial_owner_id=='Add New'?'new':'')">
                    <option value="" disabled>-- {{ cache_data_label.beneficial_owner_id }} --</option>
<!--                    <option :value="cache_data.shareholder_id" v-show="cache_data.shareholder_id && cache_data.shareholder_id != 'Add New'">Same as Shareholder</option>-->
                    <option :value="contact.id" v-for="contact in item_list.contacts" v-show="contact.id != cache_data.shareholder_id">{{ contact.formatted_name }}</option>
                    <option value="Add New">Add New</option>
                </select>
            </div>
            <p style="display:block;margin:0;padding: 0.5em 0 0.5em 1em;font-size: 0.8em;" v-show="!current_beneficial_owner_id && cache_data.beneficial_owner_id"><a style="font-size: 1.25em;text-decoration: underline;" href="javascript:void(0)" @click="current_beneficial_owner_id = cache_data.beneficial_owner_id">Click here to edit beneficial owner details</a> Note: Editing details will change them anywhere else these details are used</p>
        </div>
        <update-contact v-show="!flag_beneficial_owner_is_shareholder && current_beneficial_owner_id" :current_contact_id="current_beneficial_owner_id" @submit="change_beneficial_owner" :option="{item_list:item_list,item_map:item_map,contact_id:'beneficial_owner_'+current_shareholder_id,contact_for:'beneficial_owner'}"></update-contact>

        <div class="form_row">
            <label :for="'shareholder_'+current_shareholder_id+'_share_c_code'" v-html="cache_data_label.share_c_code" v-show="cache_data.share_c_code"></label>
            <div class="select_container">
                <select :id="'shareholder_'+current_shareholder_id+'_share_c_code'" v-model="cache_data.share_c_code" :placeholder="cache_data_label.share_c_code">
                    <option value="" disabled>-- {{ cache_data_label.share_c_code }} --</option>
                    <option :value="share_class.code" v-for="share_class in available_share_class">{{ share_class.code + ', ' + share_class.description }}</option>
                </select>
            </div>
        </div>

        <div class="form_row">
            <label :for="'shareholder_'+current_shareholder_id+'_share_paid'" v-html="cache_data_label.share_paid" v-show="cache_data.share_paid"></label>
            <p style="display:block;margin:0;padding: 0 0 0.5em 1em;font-size: 0.8em;">Please type the price per share. E.g. For 1 cent enter "0.01"</p>
            <input type="text" :id="'shareholder_'+current_shareholder_id+'_share_paid'" :placeholder="cache_data_label.share_paid" v-model="cache_data.share_paid" @change="cache_data.share_paid = $root.fix_format(cache_data.share_paid,[{type:'decimal',precision:2}])">
        </div>

        <div class="form_row">
            <label :for="'shareholder_'+current_shareholder_id+'_share_unpaid'" v-html="cache_data_label.share_unpaid" v-show="cache_data.share_unpaid !== ''"></label>
            <p style="display:block;margin:0;padding: 0 0 0.5em 1em;font-size: 0.8em;">Please type the price per share. E.g. For 1 cent enter "0.01" or "0" if fully paid. </p>
            <input type="text" :id="'shareholder_'+current_shareholder_id+'_share_unpaid'" :placeholder="cache_data_label.share_unpaid" v-model="cache_data.share_unpaid" @change="cache_data.share_unpaid = $root.fix_format(cache_data.share_unpaid,[{type:'decimal',precision:2}])">
        </div>

        <div class="form_row" v-if="$root.panel == 'admin'">
            <label :for="'shareholder_'+current_shareholder_id+'_share_currency'" v-html="cache_data_label.share_currency" v-show="cache_data.share_currency"></label>
            <input type="text" :id="'shareholder_'+current_shareholder_id+'_share_currency'" :placeholder="cache_data_label.share_currency" v-model="cache_data.share_currency">
        </div>
        <div class="form_row">
            <label :for="'shareholder_'+current_shareholder_id+'_number_of_shares'" v-html="cache_data_label.number_of_shares" v-show="cache_data.number_of_shares"></label>
            <input type="text" :id="'shareholder_'+current_shareholder_id+'_number_of_shares'" :placeholder="cache_data_label.number_of_shares" v-model="cache_data.number_of_shares" @change="cache_data.number_of_shares = $root.fix_format(cache_data.number_of_shares,[{type:'integer'}])">
        </div>
        <div class="form_row" v-if="$root.panel == 'admin'">
            <label :for="'shareholder_'+current_shareholder_id+'_certificate_type'" v-html="cache_data_label.certificate_type" v-show="cache_data.certificate_type"></label>
            <div class="select_container">
                <select :id="'shareholder_'+current_shareholder_id+'_certificate_type'" v-model="cache_data.certificate_type" :placeholder="cache_data_label.certificate_type">
                    <option value="" disabled>-- {{ cache_data_label.certificate_type }} --</option>
                    <option value="Transaction">Transaction</option>
                    <option value="Balance">Balance</option>
                    <option value="None">None</option>
                </select>
            </div>
        </div>
        <div class="form_row" v-if="$root.panel == 'admin'" v-show="cache_data.certificate_type != 'None'">
            <label :for="'shareholder_'+current_shareholder_id+'_certificate_number'" v-html="cache_data_label.certificate_number" v-show="cache_data.certificate_number"></label>
            <input type="text" :id="'shareholder_'+current_shareholder_id+'_certificate_number'" :placeholder="cache_data_label.certificate_number" v-model="cache_data.certificate_number">
        </div>

        <div class="form_row form_row_controller_container" v-show="!current_contact_id && !current_beneficial_owner_id">
            <input type="button" class="btn btn-primary" value="Save" @click="save()">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
<!--            <input type="button" class="btn btn-secondary-inverse" value="Remove" @click="remove()" v-show="current_shareholder.id">-->
        </div>
    </div>    
</template>

<script>
    export default {
        name: "UpdateShareholder",
        props: ['current_shareholder_id','option'],
        data() {
            let data_set = {
                current_contact_id: '',
                current_beneficial_owner_id: '',
                cache_data_label: {
                    shareholder_id: 'Shareholder Details',
                    beneficial_owner_id: 'Beneficial Owner Details',
                    share_c_code: 'Share Class',
                    share_paid: 'Amount Paid',
                    share_unpaid: 'Amount Unpaid',
                    share_currency: 'Currency',
                    number_of_shares: 'Number of Shares',
                    certificate_type: 'Certificate Type',
                    certificate_number: 'Certificate Number'
                },
                flag_beneficial_owner_is_shareholder: true,
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            data_set.cache_data = current_object.reset_cache_data({init:true});
            data_set.available_share_class = [];
            Object.keys(current_object.$root.available_share_class).forEach(function (key) {
                data_set.available_share_class.push({'code':key,'description':current_object.$root.available_share_class[key]});
            });
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });

            if (data_set.item_map && data_set.item_map.shareholders[current_object.current_shareholder_id]) {
                data_set.current_shareholder = data_set.item_map.shareholders[current_object.current_shareholder_id];
            } else {
                data_set.current_shareholder = {}
            }
            if (data_set.cache_data.shareholder_id && data_set.cache_data.beneficial_owner_id && data_set.cache_data.shareholder_id !== data_set.cache_data.beneficial_owner_id) {
                data_set.flag_beneficial_owner_is_shareholder = false;
            }
            return data_set;
        },
        methods: {
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;

                let cache_data = {};
                if (!option.init) {
                    cache_data = current_object.cache_data;
                }

                cache_data.id = '';
                cache_data.shareholder_id = '';
                cache_data.beneficial_owner_id = '';
                cache_data.share_c_code = '';
                cache_data.share_paid = '1.00';
                cache_data.share_unpaid = '0.00';
                cache_data.share_currency = 'AUD';
                cache_data.number_of_shares = '';
                cache_data.certificate_type = 'None';
                cache_data.certificate_number = 1;

                current_object.current_shareholder = {};
                if (current_object.current_shareholder_id && current_object.option) {
                    if (current_object.option.item_map.shareholders[current_object.current_shareholder_id]) {
                        cache_data = Object.assign(cache_data, current_object.item_map.shareholders[current_object.current_shareholder_id]);
                        current_object.current_shareholder = current_object.item_map.shareholders[current_object.current_shareholder_id];
                    }
                }
                return cache_data;

            },
            change_shareholder: function(contact_id) {
                if (!contact_id) {
                    this.cache_data.shareholder_id = '';
                } else {
                    this.cache_data.shareholder_id = contact_id;
                    // this.cache_data.beneficial_owner_id = contact_id;
                }
                this.set_beneficial_owner_id();
                this.current_contact_id = '';
            },
            set_beneficial_owner_id: function() {
                if (this.flag_beneficial_owner_is_shareholder) {
                    this.cache_data.beneficial_owner_id = this.cache_data.shareholder_id;
                } else {
                    if (this.cache_data.beneficial_owner_id === this.cache_data.shareholder_id) {
                        this.cache_data.beneficial_owner_id = '';
                    }
                }
            },
            change_beneficial_owner: function(contact_id) {
                if (!contact_id) {
                    this.cache_data.beneficial_owner_id = '';
                } else {
                    this.cache_data.beneficial_owner_id = contact_id;
                }
                this.current_beneficial_owner_id = '';
            },
            save: function () {
                let current_object = this;

                let warning_message = [];

                // General Validation, e.g. mandatory field empty, number format wrong...
                Object.keys(current_object.cache_data).forEach(function (field_name) {
                    switch (field_name) {
                        case 'shareholder_id':
                            if (current_object.cache_data[field_name] === '' || current_object.cache_data[field_name] === 'Add New') {
                                warning_message.push('"'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                        case 'share_c_code':
                        case 'share_paid':
                        case 'share_unpaid':
                        case 'share_currency':
                        case 'number_of_shares':
                            if (current_object.cache_data[field_name] === '') {
                                warning_message.push('"'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                        case 'certificate_number':
                            if (current_object.cache_data['certificate_type'] !== 'None' && current_object.cache_data[field_name] === '') {
                                warning_message.push('"'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                    }
                });
                if (warning_message.length > 0) {
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }
                if (!current_object.current_shareholder.id || !current_object.item_map.shareholders[current_object.current_shareholder.id]) {
                    current_object.current_shareholder = Object.assign(current_object.current_shareholder,current_object.cache_data);
                    let index_counter = 1;
                    while (current_object.item_map.shareholders['new_'+index_counter]) {
                        index_counter++;
                    }

                    current_object.current_shareholder.id = 'new_'+index_counter;
                    current_object.item_map.shareholders[current_object.current_shareholder.id] = current_object.current_shareholder;
                    current_object.item_list.shareholders.push(current_object.current_shareholder);
                } else {
                    current_object.current_shareholder = Object.assign(current_object.current_shareholder,current_object.cache_data);
                }
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550, 'swing', function () {
                    // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                    // (calculated top position number is correct, it is kind of browser render problem)
                    // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                    // scrollTop:$(current_object.$el).offset().top - 200;
                });
                current_object.$emit('update:current_shareholder_id',null);
console.log('allen debug UpdateShareholder submit', current_object.current_shareholder, current_object.current_shareholder_id);
                current_object.reset_cache_data();
console.log('allen debug UpdateShareholder submit 2', current_object.current_shareholder, current_object.current_shareholder_id);
                current_object.flag_beneficial_owner_is_shareholder = true;
                return current_object.current_shareholder;
            },
            cancel: function () {
                let current_object = this;

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

                current_object.flag_beneficial_owner_is_shareholder = true;

                // current_object.current_shareholder_id = 'none';
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550, 'swing', function () {
                    // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                    // (calculated top position number is correct, it is kind of browser render problem)
                    // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                    // scrollTop:$(current_object.$el).offset().top - 200;
                });
                current_object.$emit('update:current_shareholder_id',null);
            },
            remove: function () {
                let current_object = this;
                if (current_object.item_map.shareholders[current_object.current_shareholder.id]) {
                    if (current_object.current_shareholder.id.match(/^new_/)) {
                        delete current_object.item_map.shareholders[current_object.current_shareholder.id];
                    } else {
                        current_object.item_map.shareholders[current_object.current_shareholder.id].deleted = true;
                    }
                }
                let item_list_index = current_object.item_list.shareholders.indexOf(current_object.current_shareholder);
                if (item_list_index > -1) {
                    current_object.item_list.shareholders.splice(item_list_index,1);
                }

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

                current_object.flag_beneficial_owner_is_shareholder = true;

                current_object.$emit('update:current_shareholder_id',null);
                // current_object.$emit('update:item_list.shareholders',current_object.item_list.shareholders);
            }
        },
        watch: {
            current_shareholder_id: function (new_shareholder_id, old_shareholder_id) {
                this.reset_cache_data();
                if (this.cache_data.shareholder_id && this.cache_data.beneficial_owner_id && this.cache_data.shareholder_id !== this.cache_data.beneficial_owner_id) {
                    this.flag_beneficial_owner_is_shareholder = false;
                }
            }
        }
    }
</script>